'use client'
import type { FC } from 'react'
import { ProductListSearchVertical } from './VariantVerticalFilter/ProductListSearchVertical'
import { ProductListSearchHorizontal } from './VariantHorizontalFilter/ProductListSearchHorizontal'
import { type ProductListSearchProps } from './types'

export const ProductListSearch: FC<ProductListSearchProps> = ({
  variant = 'vertical-filter',
  ...props
}) => {
  switch (variant) {
    case 'vertical-filter':
      return <ProductListSearchVertical {...props} />

    case 'horizontal-filter':
      return <ProductListSearchHorizontal {...props} />
  }
}
